import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import ExcursionPage from "@/pages/ExcursionPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminLeads from "@/pages/AdminLeads";
import Analytics from "@/components/Analytics";

function App() {
    return (
        <HelmetProvider>
            <div className="App min-h-screen bg-cream text-ink">
                <BrowserRouter>
                    <Analytics />
                    <Routes>
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin/leads" element={<AdminLeads />} />
                        <Route path="/admin" element={<AdminLogin />} />
                        <Route path="/" element={<Home />} />
                        <Route path="/en" element={<Home />} />
                        <Route path="/en/:slug" element={<ExcursionPage />} />
                        <Route path="/:slug" element={<ExcursionPage />} />
                    </Routes>
                </BrowserRouter>
                <Toaster
                    theme="light"
                    position="top-center"
                    toastOptions={{
                        style: {
                            background: "#FCF8E6",
                            color: "#0F2A3F",
                            border: "2px solid #EB6741",
                            borderRadius: 10,
                        },
                    }}
                />
            </div>
        </HelmetProvider>
    );
}

export default App;
